import { render } from "./TermsGate.vue?vue&type=template&id=67d4b074&scoped=true"
import script from "./TermsGate.vue?vue&type=script&lang=js"
export * from "./TermsGate.vue?vue&type=script&lang=js"

import "./TermsGate.vue?vue&type=style&index=0&id=67d4b074&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d4b074"]])

export default __exports__